<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <div class="borbtm">
      <div class="fw-600 colorred mgb-10">
        温馨提示：以下数据为平台内所有企业合计。
      </div>
      <!-- 运营收益统计 -->
      <!-- <div class="color052173 f28 mgb-20">运营收益统计</div> -->
      <div class="stat ">
        <div class="statBox isHaveDetail">
          <div>平台实收分润（元）</div>
          <!-- <span class="detailsBtn">?</span> -->
          <el-tooltip class="item detailsBtn" placement="right-start">
            <div class="tooltipinfo" slot="content">
              平台方实际从空中分账方式收到的分润金额。因银联技术要求，仅能保留两位小数，企业方两位小数后的金额将全部划为平台方分润收益。
            </div>
            <el-button class="">?</el-button>
          </el-tooltip>
          <div class="mgt-20">{{ statistic.airPrice }}</div>
        </div>
        <div class="statBox isHaveDetail">
          <div>平台应得分润（元）</div>
          <el-tooltip class="item detailsBtn" placement="right-start">
            <div class="tooltipinfo" slot="content">
              平台方应该从空中分账方式收到的分润金额。为保证数据准确性，保留小数点后五位。
            </div>
            <el-button class="">?</el-button>
          </el-tooltip>
          <div class="mgt-20">
            {{ statistic.sharePrice }}
          </div>
        </div>
        <div class="statBox isHaveDetail">
          <div>平台分润差额（元）</div>
          <el-tooltip class="item detailsBtn" placement="right-start">
            <div class="tooltipinfo" slot="content">
              平台方从空中分账方式中多收到的分润金额。为保证数据准确性，保留小数点后五位。
            </div>
            <el-button class="">?</el-button>
          </el-tooltip>
          <div class="mgt-20">{{ statistic.marginPrice }}</div>
        </div>
      </div>
    </div>

    <!-- 查询表单区域 -->
    <div class="bg-white mgt-30 pdt-20">
      <el-form :inline="true" ref="form" :model="listForm" label-width="120px">
        <el-form-item label="订单号">
          <el-input
            v-model="listForm.orderNo"
            placeholder="请输入订单号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="订单日期">
          <el-date-picker
            v-model="listForm.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="$forceUpdate()"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="listForm.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @input="$forceUpdate()"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
        <el-button class="mgl-10" @click="resetCompany">重置</el-button>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="bg-white mgt-30 pdt-20">
      <el-table :data="tableData" style="width: 100%" border stripe>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="companyName" label="分润企业名称" />
        <el-table-column prop="orderNo" label="订单号" />
        <el-table-column prop="createTime" label="订单日期" />
        <el-table-column prop="airPrice" label="平台实收分润（元）" />
        <el-table-column prop="sharePrice" label="平台应得分润（元）" />
        <el-table-column prop="marginPrice" label="平台分润差额（元）" />
      </el-table>

      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      listForm: {
        companyId: "",
        orderNo: "",
        startTime: "",
        endTime: "",
      },
      tableData: [],
      statistic: {},
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.listForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      page: 1,
      pageSize: 10, //每页显示多少条数据，默认
      total: 0, // 数据总条数
    };
  },
  created() {
    this.listForm.companyId = this.$route.query.id;
    this.getstatistic();
    this.getList();
  },
  watch: {},
  methods: {
    // 获取统计信息
    getstatistic() {
      this.$api.shareManage
        .oneDifferenceStatistics(this.listForm)
        .then((res) => {
          if (res.code === 200) {
            this.statistic = res.data;
          }
        });
    },
    // 获取表格数据
    getList() {
      const params = {
        ...this.listForm,
        pageNum: this.page,
        pageSize: this.pageSize,
      };
      this.$api.shareManage.oneDifferenceList(params).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.rows;
          this.total = res.data.total || 0;
        }
      });
      this.getstatistic();
    },
    // 查询按钮
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    // 重置按钮
    resetCompany() {
      this.listForm.orderNo = "";
      this.listForm.startTime = "";
      this.listForm.endTime = "";
      this.page = 1;
      this.getList();
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.stat {
  display: flex;
  justify-content: space-around;
  .statBox {
    width: 300px;
    height: 150px;
    background: var(--card-bg);
    border-radius: 25px;
    color: #007bef;
    font-size: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}

.whatClass {
  width: 20px; /* 调整为适合的宽度 */
  height: 20px; /* 调整为适合的高度 */
  text-align: center;
  border-radius: 50%;
  border: 2px solid #007bef;
  color: #007bef;
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
  cursor: pointer;
}

.isHaveDetail {
  position: relative;
  .detailsBtn {
    position: absolute;
    right: 25px;
    top: 20px;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    color: #ccc;
    font-size: 14px;
    border: 1px solid var(--input-border);
    border-radius: 100%;
    cursor: pointer;
    padding: 0;
  }
}

.tooltipinfo {
  width: 150px;
}
</style>
